import React from 'react';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface QAProps {
  answer: React.ReactNode | string;
  question: string;
}

const LetterIcon = ({ letter }: { letter: string }) => <div className="qa-letter-icon">{letter}</div>;

export const QA = ({ answer, question }: QAProps) => (
  <Container className="qa-container">
    <div className="qa-header">
      <LetterIcon letter="Q" />
      <h3 className="font-bold question">{question}</h3>
    </div>
    <div className="qa-body">
      <LetterIcon letter="A" />
      {typeof answer === 'string' ? (
        <div className="answer-container" dangerouslySetInnerHTML={{ __html: sanitizeHTML(answer) }} />
      ) : (
        <div className="answer-container">{answer}</div>
      )}
    </div>
  </Container>
);

const Container = styled.div`
  &.qa-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.5rem;
    border-bottom: 1px solid ${({ theme }) => theme.colorPalette.blue200};

    .question {
      font-size: ${({ theme }) => theme.fontSize.lg};
      @media screen and (min-width: 600px) {
        font-size: ${({ theme }) => theme.fontSize.xl};
      }
    }

    > div {
      display: flex;
      align-items: baseline;

      .qa-letter-icon {
        color: ${({ theme }) => theme.colorPalette.blue500};
        font-weight: 700;
        background-color: ${({ theme }) => theme.colorPalette.blue100};
        border-radius: 0.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2rem;
        height: 2rem;
        min-width: 2rem;
        margin-right: 1rem;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        float: left;
      }

      .answer-container {
        p {
          margin-bottom: 0 !important;
        }
      }
    }

    @media screen and (max-width: 600px) {
      border: none;
      border-bottom: 1px solid #e1ebfa;
      max-width: 100%;

      &:nth-of-type(odd) {
        padding-left: 0.5rem;
      }
    }
  }
`;
